import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { BulletListBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './ListBlocks.module.css';
interface BulletListProps {
  block: BulletListBlock;
  blockId: string;
}
export function BulletList(t0) {
  const $ = _c(9);
  const {
    block,
    blockId
  } = t0;
  const t1 = block.variant === "listingSquare" ? styles.listingSquare : null;
  const t2 = block.variant === "industryLinks" ? styles.industryLinks : null;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [styles.bulletList, t1, t2].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const className = t3.join(" ");
  let t4;
  if ($[3] !== block.items) {
    t4 = block.items.map(_temp);
    $[3] = block.items;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== blockId || $[6] !== className || $[7] !== t4) {
    t5 = <ul className={className} data-cms-block-id={blockId} data-cms-field="bulletList">{t4}</ul>;
    $[5] = blockId;
    $[6] = className;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp(segments, idx) {
  return <li key={idx} className={styles.item}><RichSegments segments={segments} /></li>;
}